import { createContext, useContext } from 'react';

export type SnippetSelectorContextState = {
  showSnippetSelector: () => void;
};

export const SNIPPET_SELECTOR_CONTEXT_DEFAULT_VALUE: SnippetSelectorContextState = {
  showSnippetSelector: () => null,
};

export const SnippetSelectorContext = createContext(SNIPPET_SELECTOR_CONTEXT_DEFAULT_VALUE);

export const useSnippetSelectorContext = () => useContext(SnippetSelectorContext);
